<ng-container *transloco="let t; read: 'import-configuration-confirm-dialog-component'"
  ><div class="xi-modal__container">
    <h2 class="xi-modal__title text-center">{{ t('are-you-sure') }}</h2>

    <form (ngSubmit)="confirm()">
      <div class="xi-modal__content">
        <p class="text-center">
          {{ t('basic-warning') }}
        </p>

        <div class="import-configuration-confirm__contents">
          <div>{{ t('source') }}</div>

          <div class="import-configuration-confirm__name">{{ data().source }}</div>

          <div>{{ t('action') }}</div>

          <div class="import-configuration-confirm__action">{{ t(data().action) | titlecase }}</div>

          <div class="import-configuration-confirm__properties-label">{{ t('properties') }}</div>

          @for (item of data().items | keyvalue; track item) {
            <div class="import-configuration-confirm__properties-value">
              {{ item.key }} ({{ item.value }})
            </div>
          }
          @if (data().description) {
            <div class="import-configuration-confirm__description">
              {{ t('description') }}
            </div>
          }
          @if (data().tags) {
            <div class="import-configuration-confirm__tags">{{ t('tags') }}</div>
          }
        </div>
      </div>

      <div class="xi-modal__actions">
        <xi-default-button
          type="button"
          text="{{ t('cancel') }}"
          fill="text"
          (onClick)="cancel()"
        ></xi-default-button>

        <xi-default-button text="{{ t('continue') }}"></xi-default-button>
      </div>
    </form>
  </div>
</ng-container>
